import { useEffect } from 'react'
import Router from 'next/router'
import { appScroll } from '../utils/scroll'

const useAppScroll = () =>
  useEffect(() => {
    const handleRouteChange = () => {
      appScroll({ top: 0, left: 0, behavior: 'auto' })
    }

    Router.events.on('routeChangeStart', handleRouteChange)
    return () => {
      Router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [])

export default useAppScroll
